import { createContext, useContext, useState } from "react";
import { AudioContextType, AudioProviderProps } from "../GameTypes/game.type";


const AudioContextCustom = createContext<AudioContextType | undefined>(
  undefined
);
export const AudioProvider: React.FC<AudioProviderProps> = ({ children }) => {
  const [isMuted, setIsMuted] = useState<boolean>(false);

  return (
    <AudioContextCustom.Provider value={{ isMuted, setIsMuted }}>
      {children}
    </AudioContextCustom.Provider>
  );
};

export const useAudio = (): AudioContextType => {
  const context = useContext(AudioContextCustom);
  if (!context) {
    throw new Error("useAudio must be used within an AudioProvider");
  }
  return context;
};
